module.exports = __webpack_public_path__ + "img/doctor-2.99c6485c.png";